import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import TournamentUpdateComponent from './component'

export const TournamentUpdate = combine({
  hooks: [
    withContext(
      'adminTournamentService',
      ServicesContext,
      ({ adminTournamentService }) => adminTournamentService
    ),

    withCallbacks(
      {
        getTournamentById:
          ({ adminTournamentService }) =>
          async (tournamentId) => {
            return await adminTournamentService.getTournamentById(tournamentId)
          },
        onSubmit:
          ({ adminTournamentService }, { history }) =>
          async (tournamentDTO) => {
            await adminTournamentService.updateTournamentById(tournamentDTO)
            toaster.info('Tournament has been successfully updated')
            history.push(admin.tournaments())
          },
      },
      []
    ),
  ],
  transformProps: ({ match, getTournamentById, onSubmit }) => {
    return {
      tournamentId: Number(match.params.tournamentId),
      getTournamentById,
      onSubmit,
    }
  },
})(TournamentUpdateComponent)
